const Guarantee = () => {
  return (
    <ul className="list-unstyled mt-4 ">
      <li className="d-flex align-items-center mb-2">
        <span>
          <img
            className="ensure_photo me-2"
            src="//theme.hstatic.net/200000383169/1000797243/14/img_product_service_1.png"
            alt="Hàng chính hãng"
          />
        </span>
        <p className="mb-0 text-muted fst-italic">Đảm bảo hàng chính hãng</p>
      </li>
      <li className="d-flex align-items-center mb-2">
        <span>
          <img
            className="ensure_photo me-2"
            src="//theme.hstatic.net/200000383169/1000797243/14/img_product_service_2.png"
            alt="Giao hàng"
          />
        </span>
        <p className="mb-0 text-muted fst-italic">Giao hàng toàn quốc</p>
      </li>
      <li className="d-flex align-items-center mb-2">
        <span>
          <img
            className="ensure_photo me-2"
            src="//theme.hstatic.net/200000383169/1000797243/14/img_product_service_3.png"
            alt="Bảo hành"
          />
        </span>
        <p className="mb-0 text-muted fst-italic">
          Đổi trả do lỗi nhà sản xuất
        </p>
      </li>
    </ul>
  );
};

export default Guarantee;
